import { Factory } from 'miragejs';

export default Factory.extend({
  active: true,
  desksQuantity: 5,
  assignableDesksQuantity: 5,
  autoAssignDesk: false,

  afterCreate(deskLocation, server) {
    server.createList('workplace-day', 7, { deskLocation });
  },
});
